import { storageService } from "@trueskin-web/services"

const storageKeys = storageService.getStorageKeys()
const CUSTOMER_IO_IDENTIFY_USER_ID = storageKeys.CUSTOMER_IO_IDENTIFY_USER_ID

const EVENT_NAMES = {
  PAGE_VIEW: "page_view",
  PAGE_LEAVE: "page_leave",
  FAQ_EXPANDED: "faq_expanded",
  PRODUCT_POPUP_EXPANDED: "product_popup_expanded",
  PRODUCT_SELECTED: "product_selected",
  PRODUCT_SELECTION_CONFIRMED: "product_selection_confirmed",
}

const ciClient = () => {
  if (!window?.cioanalytics) {
    console.info(
      "Customer.io analytics client is not initialized. Ensure the script is loaded correctly."
    )
    return null
  }

  return window.cioanalytics
}

const isClientReady = () => {
  return !!window.cioanalytics
}

const identify = (userId, data) => {
  const client = ciClient()
  const identified = storageService.getItem({
    id: CUSTOMER_IO_IDENTIFY_USER_ID,
  })

  if (client && userId && data?.email && identified !== userId) {
    storageService.setItem({ id: CUSTOMER_IO_IDENTIFY_USER_ID, data: userId })
    client.identify(userId, data)
  }
}

const track = (eventName, data = {}) => {
  const client = ciClient()
  if (!client) {
    return null
  }
  client.track(eventName, data)
}

const reset = () => {
  const client = ciClient()
  if (!client) {
    return null
  }
  client.reset()
}

export { identify, track, reset, isClientReady, EVENT_NAMES }
